import React from "react";
import { Modal } from "@material-ui/core";
import styles from "../areYouSureModal/AreYouSure.module.scss";
import Button from "../../button/Button";

/**
 * Post-action prompt: after an operator attaches a VC or changes an item, ask whether to push that
 * change to Intervend. Optional — the fiscalization record is already saved; this only mirrors it to
 * Intervend so its dashboards/attribution stay in step. Not shown for excluded test taxpayers (Simons).
 */
const SyncToIntervendModal = ({ modalOpen, closeModal, onConfirm, loading, title, description }) => {
  return (
    <Modal open={modalOpen} onClose={loading ? undefined : closeModal}>
      <div className={styles.modalWrap}>
        <div className={styles.modalInner}>
          <p className={styles.modalText}>{title || "Sinhronizovati sa Intervend-om?"}</p>
          {description ? (
            <p style={{ fontSize: 14, color: "#555", textAlign: "center", marginTop: 8 }}>{description}</p>
          ) : null}
          <div className={styles.buttonsWrapper}>
            <Button name={loading ? "Šaljem..." : "Sinhronizuj"} onClick={onConfirm} disabled={loading} />
            <p
              className={styles.cancel}
              onClick={() => {
                if (!loading) closeModal();
              }}
            >
              Ne, hvala
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SyncToIntervendModal;
